import moment from 'moment';
import { days } from 'constants';

const TIME_IN_SECONDS = 24 * 60 * 60;

/**
 * Parse business hours data - Group hours by day
 * Validate 24h
 * @param {array} data Array of hours
 */
export const parseBusinessHoursData = (data) => {
  const groupedTimesByDay = data.reduce((acc, cur) => {
    let start = cur.start;
    let end = cur.end;

    if (Number.isInteger(start) && Number.isInteger(end) && end - start === 1) {
      acc[start.toString()] = {
        fullDay: true,
        hours: [{ ...cur }],
      };
    } else {
      start = cur.start.toString()[0];
      if (acc[start]) {
        acc[start].hours.push(cur);
      } else {
        acc[start] = {
          hours: [cur],
        };
      }
    }

    return acc;
  }, {});

  return Object.values(groupedTimesByDay);
};

export const parseRulesHours = (value, format = 'hh:mm A') => {
  const _date = Math.abs(value);
  const timeInSeconds = Math.round((value - Math.round(value)) * TIME_IN_SECONDS);
  const minutes = timeInSeconds / 60;
  const hours = Math.trunc(minutes / 60);
  const time = moment()
    .set('isoWeekday', Math.trunc(_date))
    .set({ hour: hours, minutes: minutes - hours * 60 })
    .format(format);
  return time;
};

export const parseRulesHoursByDays = (rules, days, startHour, endHour) => {
  let data = {};
  days.forEach((day) => {
    data[day] = {
      active: false,
      fullDay: false,
      dateRange: [],
    };
  });
  rules.forEach((rule) => {
    const day = days[Number(rule.start.toString().charAt(0)) - 1];
    data[day].dateRange.push({ from: rule.start, to: rule.end });
    data[day].active = true;
    if (rule.end - rule.start === 1) {
      data[day].fullDay = true;
    }
  });

  Object.keys(data).forEach((day, i) => {
    if (data[day].dateRange.length === 0) {
      data[day].dateRange.push({
        from: Number(i + 1 + startHour),
        to: Number(i + 1 + endHour),
      });
    }
  });
  return data;
};

/**
 * Build default business hours data
 * @param {array} rules
 */
export const defaultBusinessHoursData = (rules) => {
  const data = days.map((day, i) => {
    const dayRules = rules.find((rule) =>
      rule.hours.find((el) => Number(el.start.toString()[0]) === i + 1)
    );

    if (dayRules) {
      return {
        day,
        index: i + 1,
        ...dayRules,
      };
    }
    return {
      day,
      index: i + 1,
      closed: true,
      hours: [{ start: i + 1, end: i + 1 }],
    };
  });
  return data || [];
};
